import {
    nextTick,
    onMounted,
    onUnmounted,
    ref,
} from '@vue/composition-api';

export function useAvailableBreadcrumbWidthCalculations() {
    const breadcrumbsListRef = ref<HTMLElement>();
    const availableBreadcrumbWidth = ref<number>();

    const updateAvailableWidth = async () => {
        await nextTick();
        if (!breadcrumbsListRef.value) {
            return;
        }

        const parentEl = breadcrumbsListRef.value.parentElement;
        const containerEl = parentEl?.parentElement;

        if (containerEl == null) {
            return document.body.clientWidth;
        }

        // TODO: This should probably include margin calculations to be stable,
        // but we have none right now
        const siblings = Array.from(containerEl.children).filter((child) => child !== parentEl);

        const containerStyles = window.getComputedStyle(containerEl, null);
        const paddingLeft = parseInt(containerStyles.getPropertyValue('padding-left'), 10);
        const paddingRight = parseInt(containerStyles.getPropertyValue('padding-right'), 10);

        availableBreadcrumbWidth.value = containerEl.clientWidth
            - paddingLeft
            - paddingRight
            // Adding 16 px breathing room per item. Should have a nicer way of doing this, like flex gap (?)
            - siblings.map((sibling) => sibling.clientWidth).reduce((sum, a) => sum + a + 16, 0);
    };

    const resizeObserver = new ResizeObserver(updateAvailableWidth);

    onMounted(() => {
        updateAvailableWidth();
        const observedElement = breadcrumbsListRef.value?.parentElement;
        if (observedElement) {
            resizeObserver.observe(observedElement);
        }
    });

    onUnmounted(() => {
        resizeObserver.disconnect();
    });

    return {
        breadcrumbsListRef,
        availableBreadcrumbWidth,
    };
}
